module.exports = __webpack_public_path__ + "fonts/Rany-Medium-Italic.51b527ed.otf";